import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  AUTH_CONFIG,
  LoadingInterceptor,
  LOGIN_SUCCESS_REDIRECT,
} from '@adminprodigydesign/axis';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top', // new navigations → scroll to 0,0
        anchorScrolling: 'enabled', // URLs with #foo → scroll to id="foo"
      })
    ),
    provideClientHydration(withEventReplay()),
    provideHttpClient(),
    {
      provide: AUTH_CONFIG,
      useValue: {
        apiUrl: 'https://dev.prodigydesign.co.uk/php/login/function.php',
      },
    },
    { provide: LOGIN_SUCCESS_REDIRECT, useValue: '/admin-dashboard-demo' }, // Customize this per app
  ],
};
